import { env } from '@/env.mjs';

interface Props {
  title: string;
  background?: string;
  label?: string | null;
  icon?: string | null;
  rounded?: boolean;
}

/**
 * Get the URL of a dynamically generated OG image based on your parameters.
 * @param title large title
 * @param background background image
 * @param label small label displayed above the title
 * @param icon icon/avatar displayed in front of the title and label
 * @param rounded boolean indicating if the icon should be rendered as a circle or not
 * @returns URL of OG image.
 */
export const getOgImage = ({ title, background, label, icon, rounded }: Props) => {
  const ogImageParams = new URLSearchParams({
    background: background || `${env.NEXT_PUBLIC_HOST_URL}/images/cones-mobile.png`,
    title,
    label: label || '',
    icon: icon || '',
    ...(rounded && { rounded: 'rounded' }),
  });

  return `${env.NEXT_PUBLIC_HOST_URL}/api/og-image?${ogImageParams}`;
};
